
import { defineComponent, ref, onMounted } from "vue";
import { useI18n } from "vue-i18n";
import { Apollo, Notify } from "@/core/services";
import { GET_SUBSCRIPTION_STATUS } from "../graphql/Queries";
import { UPDATE_SYSTEM_STATUS } from "@/modules/system/system-settings-status/graphql/Mutations";
import InnerLoader from "../../../../components/InnerLoader.vue";

export default defineComponent({
	name: "payment-methods-list",
	components: { InnerLoader },
	setup() {
		const loader = ref(false);
		const loading = ref(false);
		const statuses = ref([]);
		const systemSettings = ref();
		const i18n = useI18n();

		const capitalizeWords = (string) => {
			return string.replace(/(?:^|\s)\S/g, function(a) {
				return a.toUpperCase();
			});
		};

		// Keep switch v-model in sync with API 0/1 values.
		const applySettings = (rows) => {
			const visible = rows || [];
			systemSettings.value = visible;
			statuses.value = visible.map((row) => Boolean(Number(row.status)));
		};

		// Toggle a flag by id. API flips status (1 ↔ 0); it does not receive the new boolean.
		const updateSubscriptionStatus = (id: number) => {
			loading.value = true;
			Apollo.mutate({
				mutation: UPDATE_SYSTEM_STATUS,
				variables: { id: id },
				update: (store, { data: { update_system_status } }) => {
					if (update_system_status && systemSettings.value) {
						const next = systemSettings.value.map((row) =>
							row.id === update_system_status.id ? { ...row, ...update_system_status } : row
						);
						applySettings(next);
					}
					loading.value = false;
					Notify.success(i18n.t("message.RECORD_UPDATED_SUCCESSFULLY"));
				},
			}).catch(() => {
				loading.value = false;
			});
		};

		// Loads all flags: add_without_stock (allow cart/quote when qty > stock) and subscription_status (B2B checkout subscribe UI).
		const getSubscriptionStatus = () => {
			loading.value = true;
			Apollo.watchQuery({
				query: GET_SUBSCRIPTION_STATUS,
				fetchPolicy: "network-only",
				nextFetchPolicy: "cache-only",
				errorPolicy: "all",
			}).subscribe(({ data, errors }) => {
				if (errors) {
					loading.value = false;
				}
				applySettings(data?.system_settings_status);
				loading.value = false;
			});
		};

		onMounted(() => {
			getSubscriptionStatus();
		});

		return {
			statuses,
			loader,
			loading,
			systemSettings,
			capitalizeWords,
			updateSubscriptionStatus,
		};
	},
});
